import { WizardGroupEnum } from "../enums/wizard-group-enum";
import { NAV_GROUP_LABEL_DEFAULTS } from "./nav-group-label-defaults";
import { WizardNavGroup } from "./wizard-nav-group.model";

/**
 * Three-tier resolver for WizardNavGroup.title:
 *   1. Admin per-language override — navGroup._i18n[lang].title
 *   2. Built-in default by id     — NAV_GROUP_LABEL_DEFAULTS[id][lang].title
 *   3. Base title                 — navGroup.title (the server-stored value)
 *
 * Tier 2 uses the stable `id` (WizardGroupEnum) rather than the title string,
 * so it works even when the persisted flow JSON has a literal English title
 * that overwrote the original Transloco-key default.
 */
export function getNavGroupTitle(
  navGroup: WizardNavGroup | undefined | null,
  lang: string | undefined | null,
): string {
  if (!navGroup) {
    return '';
  }
  if (lang) {
    const adminOverride = navGroup._i18n?.[lang]?.['title'];
    if (adminOverride) {
      return adminOverride;
    }
    if (navGroup.id != null) {
      const builtIn = NAV_GROUP_LABEL_DEFAULTS[navGroup.id as WizardGroupEnum]?.[lang]?.title;
      if (builtIn) {
        return builtIn;
      }
    }
  }
  return navGroup.title ?? '';
}
